import { Range } from 'types';
import { removeRangeFromRanges } from 'utils/removeRangeFromRanges';
import { FixedShare } from '../types/Share';

export default function getInitialRanges(share: FixedShare) {
  const encumbrances = share?.encumbrances;
  let ranges: Range[] = [{ from: share?.from, to: share?.to }];
  encumbrances.forEach((encumbrance) => {
    ranges = removeRangeFromRanges(
      { from: encumbrance?.from, to: encumbrance?.to },
      ranges
    );
  });

  return ranges;
}
